import { Pipe, PipeTransform } from '@angular/core';
import { RoutesService } from '@shared/services/routes/route.service';
import { ICompany } from '@collections/companies/interfaces/company.interface';
@Pipe({
    name: 'getCompanyUrl',
    standalone: true
})
export class GetCompanyUrlPipe implements PipeTransform {

  constructor(private routesService: RoutesService) {

  }

  transform(company: Partial<ICompany>, path?: string): string {
    if (!company) {
      return '';
    }
    return this.routesService.getCompanyUrl(company, path ? path : company.primaryPath);
  }

}
